/*
hc-notification-directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/notification/hc-notification-directive',['angular'], function (angular) {

    // Module Dependencies
    var dependencies = ['ui.bootstrap'];

    // Module Definition
    var mod = angular.module('hc.Notification.Directive', dependencies);

    // array of alerts
    var messages = [];

    var directive = false;


    /**
     * A directive for displaying notifications.
     */
    mod.directive('hcNotification', function () {
        return {
            restrict: 'E',
            transclude: true,
            controller: 'hcNotificationController',
            template: '<link rel=\'stylesheet\' type=\'text/css\' href=\'modules/shell/notification/hc-notification.css\' />' +
                '<div class=\'notificationServiceNotifications\' data-ng-repeat=\'message in messages track by $index\'>' +
                '<div uib-alert type=\'alert alert-block alert-{{message.type}}\' class=\'alert alert-alert alert-block alert-dismissible alert-{{message.type}}\' close=\'closeAlert($index)\'>' +
                '<h4 id=\'alertMessageId\' class=\'alert-heading\'>{{message.content}}</h4>' +
                '</div>' +
                '</div>'

        };
    });

    /**
     * A directive for displaying notifications.
     */
    mod.controller('hcNotificationController', ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.messages = messages;
        $rootScope.messages = messages;

        var result = $rootScope.$on('notification:add', function (event, data) {

            var doesExists = false;
            if ($scope.messages && $scope.messages.length > 0 && data && typeof (data) === 'object') {
                for (var i = 0, iEnd = $scope.messages.length; i < iEnd; i++) {
                    if ($scope.messages[i].content === data.content) {
                        doesExists = true;
                    }
                }
            }
            if (!doesExists) {
                $scope.messages.push(data);
            }
        });

        $scope.$on('$destroy', function () {
            result();
        });

        /**
         * close function. THis method will be called on clicking x icon and alert window will be manually dismissed
         */
        $scope.closeAlert = function (index) {
            $scope.messages.splice(index, 1);
        };
    }]);

    mod.service('NotificationService', ['$rootScope', '$document', '$compile', '$timeout','$transitions', function ($rootScope, $document, $compile, $timeout, $transitions) {

        if (!directive) {
            directive = $document.find('#shellContainer').append($compile('<div><hc-notification></hc-notification></div>')($rootScope.$new()));
        }

        function addErrorMessage(content, redirectTo) {

            addMessage('error', content);
            var releaseHandle = $transitions.onSuccess({}, function (transition) {
                if (transition.to().name !== redirectTo) {
                    angular.forEach($rootScope.messages, function (value, index) {
                        if (value.content === content && value.type === 'error') {
                            $rootScope.messages.splice(index, 1);
                            releaseHandle();
                        }
                    });
                }
            });
        }

        function addInfoMessage(content, redirectTo) {

            addMessage('info', content);
            var releaseHandle = $transitions.onSuccess({}, function (transition) {
                if (transition.to().name !== redirectTo) {
                    angular.forEach($rootScope.messages, function (value, index) {
                        if (value.content === content && value.type === 'info') {
                            $rootScope.messages.splice(index, 1);
                            releaseHandle();
                        }
                    });
                }
            });
        }

        function addSuccessMessage(content, redirectTo, timeoutInterval) {

            timeoutInterval = parseInt(timeoutInterval, 10);

            if (!(timeoutInterval > 0)) {
                timeoutInterval = 5000;
            }

            showSuccessMessage(content, redirectTo, timeoutInterval);

        }

        function showSuccessMessage(content, redirectTo, timeoutInterval) {

            addMessage('success', content);

            $timeout(function () {
                angular.forEach($rootScope.messages, function (value, index) {
                    if (value.content === content && value.type === 'success') {
                        // timing out on the same page with given timeout interval
                        $rootScope.messages.splice(index, 1);
                    }
                });
            }, timeoutInterval);

            var releaseHandle = $transitions.onSuccess({}, function (transition) {
                if (transition.to().name !== redirectTo) {
                    angular.forEach($rootScope.messages, function (value, index) {
                        if (value.content === content && value.type === 'success') {
                            //closing success alert...navigated to a different page..
                            $rootScope.messages.splice(index, 1);
                            releaseHandle();
                        }
                    });
                }
            });
        }

        function addMessage(type, content) {
            $rootScope.$broadcast('notification:add', {
                type: type,
                content: content
            });
        }

        // Public API
        return {
            addErrorMessage: addErrorMessage,
            addSuccessMessage: addSuccessMessage,
            addInfoMessage: addInfoMessage
        };
    }]);
});

